import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './reset.css';

import LandingPage from './pages/LandingPage';
import About from './pages/About';
import Transparency from './pages/Transparency';
import History from './pages/History';
import Expertises from './pages/Expertises';
import Contact from './pages/Contact';
import Companies from './pages/Companies';
import Projects from './pages/Projects';
import Associate from './pages/Associate';
import Campaign from './pages/Campaign';
import Internship from './pages/Internship';
import IES from './pages/IES/IES';
import InstSec from './pages/InstSec/InstSec';
import Cases from './pages/Cases';
import Solutions from './pages/Solutions';
import GenericSolutionPage from './pages/GenericSolutionPage/GenericSolutionPage';
import GenericCoursePage from './pages/GenericCoursePage/GenericCoursePage';
import EventPage from './pages/Eventspage';
import VagasPage from './pages/Vagaspage';
import EventsLandingPage from './pages/EventsLandingPage';

const theme = createTheme({
  palette: {
    primary: { main: '#f7c601' },
  },
});

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/expertises" element={<Expertises />} />
          <Route path="/history" element={<History />} />
          <Route path="/transparency" element={<Transparency />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/associates" element={<Associate />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/ies" element={<IES />} />
          <Route path="/inst-sec" element={<InstSec />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solution/:id" element={<GenericSolutionPage />} />
          <Route path="/evento" element={<EventPage />} />
          <Route path="/trabalhe-conosco" element={<VagasPage />} />
          <Route path="/course/:id" element={<GenericCoursePage />} />
          <Route path="/evento/:id" element={<EventsLandingPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
